export default class ContractService {
    ID?: number;
    Caption?: string;
    TNODID?: number;
}